import React, { Component } from 'react';

class Error404 extends Component {
   state = {
      data: []
   }
   
   componentDidMount() {
      
   }
   
   render() {
      return (
         <div className="Error404">

         </div>
         )
      }
   }

   export default Error404;